import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_stacktrace/development-tickets/$ticketId/_layout/issues/')({});